import { ReportHandler } from 'web-vitals';
import { craLoggerReport } from "@react-solutions/logger";

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }

  // Add terminal logging
  if (craLoggerReport) {
    craLoggerReport();
  }
};

export default reportWebVitals;
